const postfix = '[B] '

export const isServerError = message => {
  return message.slice(0, postfix.length) === postfix
}

export const createServerError = message => postfix + message
